import Carousel from './Carousel.js';


export default function AttendeeHome(){ 
return(
    <section className='attendee-section'>    
     <div className='container'>
      <div className='attendee-bg'>
      <Carousel/>
 
        <div className='row'>
          <div className='col-md-12 col-12'>
          <p>Internationally recognized,yet abundantly accessible,Photo LA cultivates connections between industry elite and up-and-coming talent alike.</p>
          <p>The longest running international photographic art fair on theWest Coast,Photo LA has been in operation for nearly three decades.</p>
          </div>
        </div>
      </div>
      </div>
     
    </section>  
)
}
 